const addDataLayer = (log, returnType) => {
  let dataLayer = window.dataLayer || []
  dataLayer.push({
    lead_id: log && log.clientImplementationUUID ? log.clientImplementationUUID : '',
    eventCategory: 'Portal de inícios - VD - Colômbia',
    eventAction: 'Cadastro',
    eventLabel: 'Formulario',
    event: 'PushEvent',
    return: returnType,
    log: log
  })
}

export { addDataLayer }
